import React from 'react';
import { Table } from 'react-bootstrap';

const UsersCount2Table = ({ report, onSortChange }) => {
    const rows = report.map(({ ssId, users }) => (
        <tr>
            <td>{ssId}</td>
            <td>{users}</td>
        </tr>
    ));

    return (
        <Table bordered responsive>
            <thead>
            <tr>
                <th onClick={() => onSortChange(`ssId`)}>SS ID</th>
                <th onClick={() => onSortChange(`users`)}>Count</th>
            </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    );
};

export default UsersCount2Table;


// WEBPACK FOOTER //
// ./src/scenes/UsersCount2/components/Table/index.js